import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable, InjectionToken } from '@angular/core';

import { catchError, map, Observable, of } from 'rxjs';

import { HALResponse } from '@valk-nx/core/lib/interfaces/hal.interface';

import { AddressInterface, GetAddressInterface } from './postal-code.interface';

//Env variable
export const POSTALCODE_SERVICE_URL = new InjectionToken<string[]>(
	'postalCode_service-url',
);

export const POSTALCODE_API_COOKIES = new InjectionToken<string[]>(
	'postalCode_api-cookies',
);

@Injectable({ providedIn: 'root' })
export class PostalCodeService {
	private readonly http = inject(HttpClient);
	private readonly url = inject(POSTALCODE_SERVICE_URL);
	private readonly apiCookies = inject<{
		withCredentials: boolean;
	}>(POSTALCODE_API_COOKIES);

	getAddress({
		country,
		postalCode,
		houseNumber,
		houseNumberAddition,
	}: GetAddressInterface): Observable<Partial<AddressInterface>> {
		const headers = new HttpHeaders();
		return this.http
			.get<
				HALResponse<AddressInterface>
			>(`${this.url}address/${country}/${postalCode.replace(/\s/g, '')}/${houseNumber}${houseNumberAddition ? `/${houseNumberAddition}` : ''}`, { ...this.apiCookies, headers, observe: 'response' })
			.pipe(
				map((response) => response.body?.data),
				map((data) => {
					return {
						...data,
						houseNumber: data?.houseNumber?.toString(),
					};
				}),
				catchError(() => of({})),
			);
	}
}
